import React from 'react';
import { MapPin, Phone, Smartphone, Mail } from 'lucide-react';
import Reveal from '@/components/Reveal';
import { CONTACT } from '@/data/contact';

export default function OfficesSection() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl mb-14">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#2563EB] mb-4 block">
            Our Offices
          </span>
          <h2
            className="font-display font-bold text-[#0B0B0B] tracking-tight leading-tight"
            style={{ fontSize: 'clamp(2rem, 4vw, 3.25rem)' }}
          >
            London & Cape Town
          </h2>
          <p className="mt-5 text-[#0B0B0B]/60 text-base lg:text-lg font-light leading-relaxed">
            A registered UK head office with a southern-hemisphere production base — giving clients
            coverage across European, African and American time zones.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {CONTACT.offices.map((o, i) => (
            <Reveal key={o.label} delay={i * 0.1}>
              <div
                className={`h-full rounded-lg p-8 border transition-all duration-500 ${
                  o.primary
                    ? 'bg-[#0B0B0B] border-[#0B0B0B] text-white'
                    : 'bg-[#F5F5F5] border-[#0B0B0B]/10 text-[#0B0B0B]'
                }`}
              >
                <div className="flex items-center gap-3 mb-6">
                  <div
                    className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                      o.primary ? 'bg-[#2563EB]' : 'bg-white border border-[#0B0B0B]/10'
                    }`}
                  >
                    <MapPin className={`w-4 h-4 ${o.primary ? 'text-white' : 'text-[#2563EB]'}`} />
                  </div>
                  <span
                    className={`text-[10px] font-semibold uppercase tracking-[0.18em] ${
                      o.primary ? 'text-[#3B82F6]' : 'text-[#0B0B0B]/45'
                    }`}
                  >
                    {o.label}
                  </span>
                </div>
                <address className="not-italic space-y-1.5">
                  {o.lines.map((l) => (
                    <p key={l} className={`text-base ${o.primary ? 'text-white/85' : 'text-[#0B0B0B]/75'}`}>
                      {l}
                    </p>
                  ))}
                </address>
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.2}>
            <div className="h-full rounded-lg p-8 bg-[#F5F5F5] border border-[#0B0B0B]/10">
              <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[#0B0B0B]/45 block mb-6">
                Direct Lines
              </span>
              <div className="space-y-4">
                <a href={CONTACT.officePhoneHref} className="flex items-center gap-3 text-[#0B0B0B]/80 hover:text-[#2563EB] transition-colors">
                  <Phone className="w-4 h-4 shrink-0 text-[#2563EB]" />
                  <span className="text-sm">Office · {CONTACT.officePhone}</span>
                </a>
                <a href={CONTACT.mobilePhoneHref} className="flex items-center gap-3 text-[#0B0B0B]/80 hover:text-[#2563EB] transition-colors">
                  <Smartphone className="w-4 h-4 shrink-0 text-[#2563EB]" />
                  <span className="text-sm">Mobile · {CONTACT.mobilePhone}</span>
                </a>
                <a href={`mailto:${CONTACT.bookings}`} className="flex items-center gap-3 text-[#0B0B0B]/80 hover:text-[#2563EB] transition-colors">
                  <Mail className="w-4 h-4 shrink-0 text-[#2563EB]" />
                  <span className="text-sm">{CONTACT.bookings}</span>
                </a>
                <a href={`mailto:${CONTACT.sales}`} className="flex items-center gap-3 text-[#0B0B0B]/80 hover:text-[#2563EB] transition-colors">
                  <Mail className="w-4 h-4 shrink-0 text-[#2563EB]" />
                  <span className="text-sm">{CONTACT.sales}</span>
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}